import React from 'react';
import checkoutEmoji from "../../../styles/img/newCheckout/checkoutStep-emoji.svg";

const CheckoutStep = ({ statusClass, content, isLastStep }) => {
  return (
    <li className="checkoutNew-recap-checkoutStep">
      {isLastStep ? <img className="checkoutNew-recap-checkoutStep-emoji" src={checkoutEmoji} /> : <div className={`checkoutNew-recap-checkoutStep-status ${statusClass}`} />}
      <p className={`checkoutNew-recap-checkoutStep-text ${statusClass}`}>{content}</p>
    </li>
  )
}

export default CheckoutStep;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/CheckoutStep.js